<template>
  <b-card
    class="event-preview"
    :class="eventClass"
    :header="header"
  >
    <table>
      <tr>
        <th>Time</th>
        <td>{{event.time | getMomentMinStr}}</td>
      </tr>
      <tr>
        <th>Platform</th>
        <td>{{event.platform | getPlatformName}}</td>
      </tr>
      <tr>
        <th>Event id</th>
        <td>{{event.eventId}}</td>
      </tr>
      <tr>
        <th>Audience</th>
        <td>{{event.audience | getAudienceName}}</td>
      </tr>
      <tr>
        <th>Sequence</th>
        <td>{{event.sequenceProtoId | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>Level number</th>
        <td>{{event.levelNumber}}</td>
      </tr>
      <tr>
        <th>Level proto</th>
        <td>{{event.levelProtoId | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>Level revision</th>
        <td>{{event.levelRevision}}</td>
      </tr>
      <tr>
        <th>Seed</th>
        <td>{{event.seed}}</td>
      </tr>
      <tr>
        <th>Attempt</th>
        <td>{{event.attempt}}</td>
      </tr>
      <tr>
        <th>Flag used any boosters</th>
        <td>{{event.flagUsedAnyBoosters}}</td>
      </tr>
      <tr>
        <th>Flag purchased turns</th>
        <td>{{event.flagPurchasedTurns}}</td>
      </tr>
      <tr>
        <th>Turns taken</th>
        <td>{{event.turnsTaken}}</td>
      </tr>
      <tr>
        <th>Result</th>
        <td>{{resultStr}}</td>
      </tr>
    </table>

  </b-card>
</template>

<script>
import { getAudienceName } from '../model/m3level.js';

export default {
  name: 'PlayerLevelFinishedEventPreview',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    event: {
      type: Object,
      required: true,
    },
  },

  
  computed: {
    header() {
      return 'Level ' + this.event.levelNumber;
    },

    eventClass() {
      return this.event.won ? 'win' : 'defeat';
    },

    resultStr() {
      return this.event.won ? 'win' : 'defeat';
    },
  },

  filters: {
    getAudienceName,
  },
};
</script>

<style scoped>
.event-preview .card-body,
.event-preview .card-header {
  padding: 10px;
}

.win .card-header {
  background-color: #c3e6cb;
}

.defeat .card-header {
  background-color: rgba(248, 215, 218);
}

.event-preview th {
  padding-right: .5rem;
}
</style>
